import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useStore } from "../../store/useStore"

const MAX_SHOWN = 3

export function SelectionBadge() {
  const { translate } = useTranslation()
  const { actionState } = useStore()

  if (
    !actionState ||
    actionState.type !== "export" ||
    actionState.phase !== "select"
  )
    return null

  const pkValues = actionState.primaryPkValues
  if (pkValues.length === 0) return null

  const primaryScope = useStore
    .getState()
    .scopes.find((s) => s.id === actionState.primaryScopeId)
  const scopeName = primaryScope?.name ?? translate("QMS/SCOPE/FALLBACK_NAME")

  return (
    <div className="flex items-center gap-2 border-b border-grey4 bg-grey1/80 px-4 py-1.5">
      <span className="shrink-0 text-xs text-grey5">
        {translate("QMS/SELECTION/IN_SCOPE", { scope: scopeName })}
      </span>
      {pkValues.length <= MAX_SHOWN ? (
        <div className="flex flex-wrap items-center gap-1.5">
          {pkValues.map((pk) => (
            <span
              key={pk}
              className="rounded-full border border-yellow5/40 bg-yellow5/20 px-2 py-0.5 text-xs text-yellow1"
            >
              {pk}
            </span>
          ))}
        </div>
      ) : (
        <span className="rounded-full border border-yellow5/40 bg-yellow5/20 px-2 py-0.5 text-xs text-yellow1">
          {translate("QMS/SELECTION/RECORDS_SELECTED", {
            count: pkValues.length,
          })}
        </span>
      )}
    </div>
  )
}
